module.exports = __webpack_public_path__ + "img/FiSICA.bc61a953.png";